import { createContext, useContext, useEffect, useLayoutEffect, useState } from "react";
import "../theme.css";

export const THEME_STORAGE_KEY = "3dp_tema";
const validPreference = value => ["dark", "light", "system"].includes(value) ? value : "dark";
const ThemeContext = createContext({ preference: "dark", theme: "dark", setPreference: () => {} });

export function AppThemeProvider({ children }) {
  const [preference, setValue] = useState(() => {
    try { return validPreference(localStorage.getItem(THEME_STORAGE_KEY)); } catch { return "dark"; }
  });
  const [systemLight, setSystemLight] = useState(() => window.matchMedia?.("(prefers-color-scheme: light)").matches || false);
  const theme = preference === "system" ? (systemLight ? "light" : "dark") : preference;

  useEffect(() => {
    const media = window.matchMedia?.("(prefers-color-scheme: light)");
    const update = () => setSystemLight(media?.matches || false);
    const sync = event => {
      if (event.key === THEME_STORAGE_KEY || event.key === null) setValue(validPreference(event.newValue));
    };
    update();
    media?.addEventListener("change", update);
    window.addEventListener("storage", sync);
    return () => { media?.removeEventListener("change", update); window.removeEventListener("storage", sync); };
  }, []);

  useLayoutEffect(() => {
    const root = document.documentElement;
    const previous = root.getAttribute("data-pc-theme");
    root.setAttribute("data-pc-theme", theme);
    return () => {
      if (previous === null) root.removeAttribute("data-pc-theme");
      else root.setAttribute("data-pc-theme", previous);
    };
  }, [theme]);

  const setPreference = value => {
    const next = validPreference(value);
    setValue(next);
    try { localStorage.setItem(THEME_STORAGE_KEY, next); } catch {}
  };
  return <ThemeContext.Provider value={{ preference, theme, setPreference }}>{children}</ThemeContext.Provider>;
}

export function useAppTheme() { return useContext(ThemeContext); }
